import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toggleAssetFavorite } from '@/utils/assetFavorites';
import { toast } from 'sonner';

export function useAssetFavorite(assetId: string, currentStatus: boolean) {
  const queryClient = useQueryClient();

  const toggleMutation = useMutation({
    mutationFn: () => toggleAssetFavorite(assetId),
    onMutate: async () => {
      // Optimistic update - immediately flip the UI
      return { previousStatus: currentStatus };
    },
    onSuccess: (newStatus) => {
      // Invalidate relevant queries to refetch data
      queryClient.invalidateQueries({ queryKey: ['collection-assets'] });
      queryClient.invalidateQueries({ queryKey: ['asset', assetId] });

      toast.success(newStatus ? 'Added to favorites' : 'Removed from favorites');
    },
    onError: (error, variables, context) => {
      // Revert optimistic update on error
      toast.error(`Failed to update favorite: ${error.message}`);
      queryClient.invalidateQueries({ queryKey: ['collection-assets'] });
    },
  });

  return {
    toggleFavorite: toggleMutation.mutate,
    isToggling: toggleMutation.isPending,
  };
}
